import React from "react";
import { Input } from "@/shared/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/ui/select"
import { useTranslation } from "react-i18next";

export function TemplateEditorMetaFields({
  templateId,
  name,
  setName,
  toolId,
  setToolId,
  ownerType,
  setOwnerType,
  tools,
  ownershipOptions,
  isAdmin,
  isReadOnly,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-4">
      <div className="flex flex-col gap-2 sm:w-[100px] shrink-0">
        <label className="text-sm font-semibold">{t("profile.templates.fields.id")}</label>
        <Input
          value={templateId ?? ""}
          disabled
          tabIndex={-1}
          className="disabled:opacity-100 pointer-events-none"
        />
      </div>
      <div className="flex flex-col gap-2 flex-1">
        <label className="text-sm font-semibold">{t("profile.templates.fields.templateName")}</label>
        <Input value={name} onChange={(e) => setName(e.target.value)} disabled={isReadOnly} />
      </div>
      <div className="flex flex-col gap-2 flex-1">
        <label className="text-sm font-semibold">{t("profile.templates.fields.tool")}</label>
        <Select
          value={toolId || ""}
          onValueChange={(v) => setToolId(v)}
          disabled={isReadOnly}
        >
          <SelectTrigger>
            <SelectValue placeholder={t("profile.templates.fields.selectTool")} />
          </SelectTrigger>
          <SelectContent>
            {tools.map((tool) => (
              <SelectItem key={tool.id} value={tool.id}>
                {tool.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {isAdmin ? (
        <div className="flex flex-col gap-2 flex-1">
          <label className="text-sm font-semibold">{t("profile.templates.fields.ownership")}</label>
          <Select
            value={ownerType || ""}
            onValueChange={(v) => setOwnerType(v)}
            disabled={isReadOnly}
          >
            <SelectTrigger>
              <SelectValue placeholder={t("profile.templates.fields.selectOwnership")} />
            </SelectTrigger>
            <SelectContent>
              {ownershipOptions.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ) : null}
    </div>
  );
}
